module.exports = __webpack_public_path__ + "static/media/credit_card.9f9197aa.png";